export function lineRangeContains({from, to}, other) {
  if (from > to || other.from > other.to) {
    throw "Improper range";
  }
  return other.from >= from && to >= other.to && to > other.from && from < other.to;
}

export function blockRangeContains({from, to}, other) {
  if (from > to || other.from > other.to) {
    throw "Improper range";
  }
  if (from === other.from && to === other.to) {
    return true;
  }
  return other.from >= from && to >= other.to;
}

export function rangeIntersect({from, to}, other) {
  if (from > to || other.from > other.to) {
    throw "Improper range";
  }
  if (from > other.from || to > other.from) {
    return to < other.to || from < other.to;
  }
  return false;
}
